// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ── Global thin scrollbars ────────────────────────────────────── */
* {
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}
*::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background-color: #e2e8f0;
  border-radius: 9999px;
}
*::-webkit-scrollbar-thumb:hover {
  background-color: #cbd5e1;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.6s ease-out forwards;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.animate-shimmer {
  animation: shimmer 2s infinite linear;
  background: linear-gradient(to right, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%);
  background-size: 1000px 100%;
}

/* Aurora Mesh Background */
.aurora-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.55;
  will-change: transform;
}

.aurora-orb-1 {
  width: 600px;
  height: 600px;
  top: -120px;
  left: -100px;
  background: radial-gradient(circle, var(--color-primary, #6366f1) 0%, transparent 70%);
  animation: aurora-drift-1 18s ease-in-out infinite;
  opacity: 0.3;
}

.aurora-orb-2 {
  width: 500px;
  height: 500px;
  top: 30%;
  right: -80px;
  background: radial-gradient(circle, var(--color-secondary, #06b6d4) 0%, transparent 70%);
  animation: aurora-drift-2 22s ease-in-out infinite;
  opacity: 0.25;
}

.aurora-orb-3 {
  width: 450px;
  height: 450px;
  bottom: -80px;
  left: 30%;
  background: radial-gradient(circle, #818cf8 0%, transparent 70%);
  animation: aurora-drift-3 26s ease-in-out infinite;
  opacity: 0.2;
}

.aurora-orb-4 {
  width: 350px;
  height: 350px;
  top: 20%;
  left: 40%;
  background: radial-gradient(circle, #e0e7ff 0%, transparent 70%);
  animation: aurora-drift-4 20s ease-in-out infinite;
  opacity: 0.5;
}

@keyframes aurora-drift-1 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33%       { transform: translate(60px, 80px) scale(1.08); }
  66%       { transform: translate(-40px, 50px) scale(0.95); }
}

@keyframes aurora-drift-2 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33%       { transform: translate(-80px, -60px) scale(1.1); }
  66%       { transform: translate(50px, -30px) scale(0.92); }
}

@keyframes aurora-drift-3 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50%       { transform: translate(70px, -90px) scale(1.12); }
}

@keyframes aurora-drift-4 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  40%       { transform: translate(-50px, 60px) scale(1.06); }
  80%       { transform: translate(40px, -40px) scale(0.94); }
}

/* Shimmer effect for header */
.shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shimmer-slide 3s infinite;
}

@keyframes shimmer-slide {
  0% {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

/* Wave animation */
@keyframes wave {
  0%, 100% {
    transform: translateX(-50%) translateY(0) rotate(0deg);
  }
  25% {
    transform: translateX(-40%) translateY(-20px) rotate(1deg);
  }
  50% {
    transform: translateX(-50%) translateY(0) rotate(0deg);
  }
  75% {
    transform: translateX(-60%) translateY(-20px) rotate(-1deg);
  }
}

.animate-wave {
  animation: wave 20s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE;EACE,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,qCAAqC;EACrC,kGAAkG;EAClG,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,wFAAwF;EACxF,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;EACT,gEAAgE;EAChE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gEAAgE;EAChE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,YAAY,4CAA4C,EAAE;EAC1D,YAAY,6CAA6C,EAAE;AAC7D;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,YAAY,6CAA6C,EAAE;EAC3D,YAAY,6CAA6C,EAAE;AAC7D;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,YAAY,6CAA6C,EAAE;AAC7D;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,YAAY,6CAA6C,EAAE;EAC3D,YAAY,6CAA6C,EAAE;AAC7D;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,oCAAoC;AACtC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,sDAAsD;EACxD;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,sDAAsD;EACxD;EACA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ── Global thin scrollbars ────────────────────────────────────── */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n*::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n*::-webkit-scrollbar-thumb {\n  background-color: #e2e8f0;\n  border-radius: 9999px;\n}\n*::-webkit-scrollbar-thumb:hover {\n  background-color: #cbd5e1;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.6s ease-out forwards;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n.animate-shimmer {\n  animation: shimmer 2s infinite linear;\n  background: linear-gradient(to right, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%);\n  background-size: 1000px 100%;\n}\n\n/* Aurora Mesh Background */\n.aurora-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.55;\n  will-change: transform;\n}\n\n.aurora-orb-1 {\n  width: 600px;\n  height: 600px;\n  top: -120px;\n  left: -100px;\n  background: radial-gradient(circle, var(--color-primary, #6366f1) 0%, transparent 70%);\n  animation: aurora-drift-1 18s ease-in-out infinite;\n  opacity: 0.3;\n}\n\n.aurora-orb-2 {\n  width: 500px;\n  height: 500px;\n  top: 30%;\n  right: -80px;\n  background: radial-gradient(circle, var(--color-secondary, #06b6d4) 0%, transparent 70%);\n  animation: aurora-drift-2 22s ease-in-out infinite;\n  opacity: 0.25;\n}\n\n.aurora-orb-3 {\n  width: 450px;\n  height: 450px;\n  bottom: -80px;\n  left: 30%;\n  background: radial-gradient(circle, #818cf8 0%, transparent 70%);\n  animation: aurora-drift-3 26s ease-in-out infinite;\n  opacity: 0.2;\n}\n\n.aurora-orb-4 {\n  width: 350px;\n  height: 350px;\n  top: 20%;\n  left: 40%;\n  background: radial-gradient(circle, #e0e7ff 0%, transparent 70%);\n  animation: aurora-drift-4 20s ease-in-out infinite;\n  opacity: 0.5;\n}\n\n@keyframes aurora-drift-1 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  33%       { transform: translate(60px, 80px) scale(1.08); }\n  66%       { transform: translate(-40px, 50px) scale(0.95); }\n}\n\n@keyframes aurora-drift-2 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  33%       { transform: translate(-80px, -60px) scale(1.1); }\n  66%       { transform: translate(50px, -30px) scale(0.92); }\n}\n\n@keyframes aurora-drift-3 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50%       { transform: translate(70px, -90px) scale(1.12); }\n}\n\n@keyframes aurora-drift-4 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  40%       { transform: translate(-50px, 60px) scale(1.06); }\n  80%       { transform: translate(40px, -40px) scale(0.94); }\n}\n\n/* Shimmer effect for header */\n.shimmer {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  animation: shimmer-slide 3s infinite;\n}\n\n@keyframes shimmer-slide {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 200%;\n  }\n}\n\n/* Wave animation */\n@keyframes wave {\n  0%, 100% {\n    transform: translateX(-50%) translateY(0) rotate(0deg);\n  }\n  25% {\n    transform: translateX(-40%) translateY(-20px) rotate(1deg);\n  }\n  50% {\n    transform: translateX(-50%) translateY(0) rotate(0deg);\n  }\n  75% {\n    transform: translateX(-60%) translateY(-20px) rotate(-1deg);\n  }\n}\n\n.animate-wave {\n  animation: wave 20s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
